import styled, {css} from "styled-components";
import React from "react";

export const buttonStyle = css`
  cursor: ${({disabled}) => (disabled ? "not-allowed" : "pointer")};
  background-color: transparent;
  border-radius: 50px;
  &:hover {
    opacity: 0.6;
  }
  &:focus {
    outline: none;
  }
`;

const ButtonContainer = styled.button`
  ${buttonStyle}
`;

export default function (props) {
  return <ButtonContainer {...props} />;
}
